import { createEditor, $getRoot, $createParagraphNode } from 'lexical';
import { $generateHtmlFromNodes } from '@lexical/html';
import { editorNodes } from '../Nodes';
import { editorTheme } from '../Themes/EditorTheme';
import { decodeSanitizedEntities } from './EditorNodeUtils';

let cachedEditor = null;

function getRenderEditor() {
    if (!cachedEditor) {
        cachedEditor = createEditor({
            namespace: 'GfuEditorRenderer',
            theme: editorTheme,
            nodes: editorNodes,
            // eslint-disable-next-line no-console
            onError: (error) => console.error('[Editor Renderer]', error),
        });
    }

    return cachedEditor;
}

export function convertJsonToHtml(jsonString) {
    if (!jsonString) return '';

    try {
        const editor = getRenderEditor();
        const parsed = typeof jsonString === 'string' ? JSON.parse(decodeSanitizedEntities(jsonString)) : jsonString;
        const state = editor.parseEditorState(parsed);

        let html = '';

        editor.setEditorState(state);
        editor.update(
            () => {
                html = $generateHtmlFromNodes(editor);
            },
            { discrete: true },
        );

        // Reset the cached editor after use; a single paragraph, not empty root (setEditorState rejects empty states).
        editor.update(
            () => {
                const root = $getRoot();
                root.clear();
                root.append($createParagraphNode());
            },
            { discrete: true },
        );

        return html;
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error('[Editor Renderer] Failed to convert JSON to HTML:', e);
        return '';
    }
}
